<div class="chart-wrapper h-100 w-100 notranslate">
    <canvas baseChart class="bar h-100" [attr.height]="fullScreen ? null : height"
            [style.min-height]="fullScreen ? '0' : height + 'px'"
            [data]="chartData"
            [options]="getOptions()"
            [type]="'scatter'"
            [plugins]="plugins">
    </canvas>
</div>
